import { render, staticRenderFns } from "./GSCQueriesPopup.vue?vue&type=template&id=0466c2f5&scoped=true"
import script from "./GSCQueriesPopup.vue?vue&type=script&lang=js"
export * from "./GSCQueriesPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466c2f5",
  null
  
)

export default component.exports